/** @jsx jsx */
import { Fragment } from "react"
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import questionOutlineSvg from "./questionOutlineIcon.svg"

export const questionOutlineIcon = vwoService.isThemeRebrandedEnabled()
  ? questionOutlineSvg
  : {
      path: (
        <g stroke="currentColor" strokeWidth="1.5">
          <path
            strokeLinecap="full"
            fill="none"
            d="M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
          />
          <path
            fill="none"
            strokeLinecap="full"
            d="M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
          />
          <circle fill="none" strokeMiterlimit="10" cx="12" cy="12" r="11.25" />
        </g>
      ),
    }
